export enum VerificationType {
    Pin = "Pin",
    MultiFactor = "MultiFactor"
}

export const VERIFICATION_TYPES = [
    VerificationType.Pin,
    VerificationType.MultiFactor,
];